import { formatRoundedNumber } from '@/lib/formatUtils';
import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BottomBarProps {
  totalAmount: number;
  totalAmountNT: number;
  formMode: FormMode;
  ty_gia?: number;
}

export const BottomBar: React.FC<BottomBarProps> = ({ totalAmount, totalAmountNT, formMode, ty_gia = 1 }) => {
  const isVND = ty_gia === 1;

  return (
    <div className='w-full border-t bg-white px-4 py-2'>
      <div className='flex'>
        <div className='ml-4 flex flex-col'>
          <div className='flex items-center gap-4'>
            <Label className='w-32 font-medium'>Tổng tiền</Label>
            <FormField
              name='t_tien_nt'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(totalAmountNT)}
            />
            <FormField
              name='t_tien'
              type='text'
              disabled={true}
              labelClassName='mr-2 font-medium'
              inputClassName='text-right'
              value={formatRoundedNumber(totalAmount)}
              className={isVND ? 'hidden' : ''}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
